import { getDeviceInfo } from '../../Api/deviceinfo';
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { utils } from '@ohif/core';
import { DragAndDropProvider, EmptyStudies, ImageViewerProvider, LoadingIndicatorProgress } from '@ohif/ui';
import useSearchParams from '../../../src/hooks/useSearchParams';
import { useAppConfig } from '../../../src/state';
import ViewportGrid from '../../../src/components/ViewportGrid';
import Compose from '../../../src/routes/Mode/Compose';
import { history } from '../../../src/utils/history';
import loadModules from '../../../src/pluginImports';
import { defaultRouteInit } from '../../../src/routes/Mode/defaultRouteInit';
import { DicomMetadataStore, ServicesManager, Types, log } from '@ohif/core';
import { t } from 'i18next';
import { fetchImage } from "../../FileServer/fileserver";
import { useNamelKey, fetchStudyList, userUrlKey, tokenKey, logout, getToken,fetchStudyLists } from "../../Api/Apicntroller";
import CryptoJS from 'crypto-js';

const { getSplitParam } = utils;

export default function ModeRoute({
  mode,
  dataSourceName,
  extensionManager,
  servicesManager,
  commandsManager,
  hotkeysManager,
}: withAppTypes) {

  //para
  const [appConfig] = useAppConfig();
  const queryParameters = new URLSearchParams(window.location.search)
  const location = useLocation();
  const params = useParams();
  const query = useSearchParams();
  let [error, setError] = useState("");

  let [loading, setLoading] = useState(true);
  let [instancesLength, setNumberInstance] = useState(0);
  let [loadedCount, setLoadedCount] = useState(0);
  const navigate = useNavigate();
  const patientid = queryParameters.get("patientId");
  const  patientids= queryParameters.get("patientIds");



  let generateDeviceId = (info: Record<string, string | number>) => {
    const infoString = Object.values(info).join(' | ');
    return CryptoJS.MD5(infoString).toString();
  };
  mode?.onModeInit?.({
    servicesManager,
    extensionManager,
    commandsManager,
    appConfig,
    query,
  });



  // The URL's query search parameters where the keys are all lower case.
  const lowerCaseSearchParams = useSearchParams({ lowerCaseKeys: true });

  const [studyInstanceUIDs, setStudyInstanceUIDs] = useState(null);

  const [refresh, setRefresh] = useState(false);
  const [ExtensionDependenciesLoaded, setExtensionDependenciesLoaded] = useState(false);

  const layoutTemplateData = useRef(false);
  const locationRef = useRef(null);
  const isMounted = useRef(false);

  // Expose the react router dom navigation.
  history.navigate = useNavigate();

  if (location !== locationRef.current) {
    layoutTemplateData.current = null;
    locationRef.current = location;
  }

  const { displaySetService, panelService, hangingProtocolService, userAuthenticationService } =
    servicesManager.services;

  const { extensions, sopClassHandlers, hotkeys: hotkeyObj, hangingProtocol } = mode;

  const runTimeHangingProtocolId = lowerCaseSearchParams.get('hangingprotocolid');


  // Preserve the old array interface for hotkeys
  const hotkeys = Array.isArray(hotkeyObj) ? hotkeyObj : hotkeyObj?.hotkeys;
  const hotkeyName = hotkeyObj?.name || 'hotkey-definitions';

  // An undefined dataSourceName implies that the active data source that is already set in the ExtensionManager should be used.
  if (dataSourceName !== undefined) {
    extensionManager.setActiveDataSource(dataSourceName);
  }

  const dataSource = extensionManager.getActiveDataSource()[0];

  // Only handling one route per mode for now
  const route = mode.routes[0];

  useEffect(() => {
    const loadExtensions = async () => {
      const loadedExtensions = await loadModules(Object.keys(extensions));
      for (const extension of loadedExtensions) {
        const { id: extensionId } = extension;
        if (extensionManager.registeredExtensionIds.indexOf(extensionId) === -1) {
          await extensionManager.registerExtension(extension);
        }
      }
      setExtensionDependenciesLoaded(true);
    };

    loadExtensions();
  }, []);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);





  const initializeDataSource = async (params, query) => {

    const deviceID = generateDeviceId(getDeviceInfo());
    setError("");
    setLoading(true);
    setLoadedCount(0);
    setNumberInstance(0);
    DicomMetadataStore.clearstudy();
    let studylist = [];
    let result;
    if(patientids&&patientids!==""&&patientids!==undefined) result= await fetchStudyLists(patientids);
    else  result= await fetchStudyList(patientid, deviceID);
    if (result && result.status === -2) {
      await logout();
      localStorage.setItem(userUrlKey, window.location.href);
      localStorage.setItem(useNamelKey, patientid);
      navigate('/login'); return;
    }
    if (!result || (result.status??0) === -1) {
      setLoading(false);
      setError("Network error !");
      return;
    }
    if (result && result.data)
      studylist = result.data;
    if (studylist === null) studylist = [];
    if (studylist) {
      setNumberInstance(studylist.length);
      for (let i = 0; i < studylist.length; i++) {
        const dicomJSONDataset = await fetchImage(studylist[i]["PublicURL"].toString());
        if (dicomJSONDataset)
          DicomMetadataStore.addInstance(dicomJSONDataset);
        setLoadedCount(i + 1);
      }
    }
    else {
      navigate('/notfoundstudy');
      return;
    }
    await dataSource.initialize({
      params,
      query,
    });
    setLoading(false);
    try {
      setStudyInstanceUIDs([studylist[0]["studyInstanceUid"].toString()]);
    }
    catch (u) { }
  };


  useEffect(() => {
    if (!ExtensionDependenciesLoaded) {
      return;
    }
    initializeDataSource(params, query);
    return () => {
      layoutTemplateData.current = null;
    };
  }, [location, ExtensionDependenciesLoaded]);

  useEffect(() => {
    if (!ExtensionDependenciesLoaded || !studyInstanceUIDs?.length) {
      return;
    }

    const retrieveLayoutData = async () => {
      const layoutData = await route.layoutTemplate({
        location,
        servicesManager,
        studyInstanceUIDs,
      });

      if (isMounted.current) {
        const { leftPanels = [], rightPanels = [], ...layoutProps } = layoutData.props;

        panelService.reset();
        panelService.addPanels(panelService.PanelPosition.Left, leftPanels);
        panelService.addPanels(panelService.PanelPosition.Right, rightPanels);

        // layoutProps contains all props but leftPanels and rightPanels
        layoutData.props = layoutProps;

        layoutTemplateData.current = layoutData;
        setRefresh(!refresh);
      }
    };
    if (Array.isArray(studyInstanceUIDs) && studyInstanceUIDs[0]) {
      retrieveLayoutData();
    }
    return () => {
      layoutTemplateData.current = null;
    };
  }, [studyInstanceUIDs, ExtensionDependenciesLoaded]);

  useEffect(() => {
    if (!hotkeys || !ExtensionDependenciesLoaded || !studyInstanceUIDs?.length) {
      return;
    }

    hotkeysManager.setDefaultHotKeys(hotkeys);

    const userPreferredHotkeys = JSON.parse(localStorage.getItem(hotkeyName));

    if (userPreferredHotkeys?.length) {
      hotkeysManager.setHotkeys(userPreferredHotkeys, hotkeyName);
    } else {
      hotkeysManager.setHotkeys(hotkeys, hotkeyName);
    }

    return () => {
      hotkeysManager.destroy();
    };
  }, [ExtensionDependenciesLoaded, hotkeys, studyInstanceUIDs]);

  useEffect(() => {
    if (!layoutTemplateData.current || !ExtensionDependenciesLoaded || !studyInstanceUIDs?.length) {
      return;
    }

    const setupRouteInit = async () => {
      // TODO: For some reason this is running before the Providers
      // are calling setServiceImplementation
      // TODO -> iterate through services.

      // Extension

      // Add SOPClassHandlers to a new SOPClassManager.
      displaySetService.init(extensionManager, sopClassHandlers);

      extensionManager.onModeEnter({
        servicesManager,
        extensionManager,
        commandsManager,
        appConfig,
      });

      // use the URL hangingProtocolId if it exists, otherwise use the one
      // defined in the mode configuration
      const hangingProtocolIdToUse = hangingProtocolService.getProtocolById(
        runTimeHangingProtocolId
      )
        ? runTimeHangingProtocolId
        : hangingProtocol;

      // Sets the active hanging protocols - if hangingProtocol is undefined,
      // resets to default.  Done before the onModeEnter to allow the onModeEnter
      // to perform custom hanging protocol actions
      hangingProtocolService.setActiveProtocolIds(hangingProtocolIdToUse);

      mode?.onModeEnter({
        servicesManager,
        extensionManager,
        commandsManager,
        appConfig,
      });

      /**
       * The next line should get all the query parameters provided by the URL
       * - except the StudyInstanceUIDs - and create an object called filters
       * used to filtering the study as the user wants otherwise it will return
       * a empty object.
       *
       * Example:
       * const filters = {
       *   seriesInstanceUID: 1.2.276.0.7230010.3.1.3.1791068887.5412.1620253993.114611
       * }
       */
      const filters =
        Array.from(query.keys()).reduce((acc: Record<string, string>, val: string) => {
          const lowerVal = val.toLowerCase();
          // Not sure why the case matters here - it doesn't in the URL
          if (lowerVal === 'seriesinstanceuids') {
            const seriesUIDs = getSplitParam(lowerVal, query);
            return {
              ...acc,
              seriesInstanceUID: seriesUIDs,
            };
          }
          return { ...acc, [val]: getSplitParam(lowerVal, query) };
        }, {}) ?? {};

      let unsubs;

      if (route.init) {
        unsubs = await route.init(
          {
            servicesManager,
            extensionManager,
            hotkeysManager,
            studyInstanceUIDs,
            dataSource,
            filters,
          },
          hangingProtocolIdToUse
        );
      }

      return defaultRouteInit(
        {
          servicesManager,
          studyInstanceUIDs,
          dataSource,
          filters,
          appConfig,
        },
        hangingProtocolIdToUse
      );
    };

    let unsubscriptions;
    setupRouteInit().then(unsubs => {
      unsubscriptions = unsubs;

      // Some code may need to run after hanging protocol initialization
      // (eg: workflowStepsService initialization on 4D mode)
      mode?.onSetupRouteComplete?.({
        servicesManager,
        extensionManager,
        commandsManager,
      });
    });

    return () => {
      // The mode.onModeExit must be done first to allow it to store
      // information, and must be in a try/catch to ensure subscriptions
      // are unsubscribed.
      try {
        mode?.onModeExit?.({
          servicesManager,
          extensionManager,
          appConfig,
        });
      } catch (e) {
        console.warn('mode exit failure', e);
      }
      // The unsubscriptions must occur before the extension onModeExit
      // in order to prevent exceptions during cleanup caused by spurious events
      if (unsubscriptions) {
        unsubscriptions.forEach(unsub => {
          unsub();
        });
      }
      // The extension manager must be called after the mode, this is
      // expected to cleanup the state to a standard setup.
      extensionManager.onModeExit();
    };
  }, [
    mode,
    dataSourceName,
    location,
    ExtensionDependenciesLoaded,
    route,
    servicesManager,
    extensionManager,
    hotkeysManager,
    studyInstanceUIDs,
    refresh,
  ]);


  const ViewportGridWithDataSource = props => {
    return ViewportGrid({ ...props, dataSource });
  };

  const CombinedExtensionsContextProvider = createCombinedContextProvider(
    extensionManager,
    servicesManager,
    commandsManager
  );

  const getLayoutComponent = props => {
    const layoutTemplateModuleEntry = extensionManager.getModuleEntry(
      layoutTemplateData.current.id
    );
    const LayoutComponent = layoutTemplateModuleEntry.component;

    return <LayoutComponent {...props} />;
  };

  const LayoutComponent = layoutTemplateData.current ? getLayoutComponent({
    ...layoutTemplateData.current.props,
    ViewportGridComp: ViewportGridWithDataSource,
  }) : undefined;

  if (loading)
    return (
      <div className="flex flex-col items-center justify-center pt-48">
        <LoadingIndicatorProgress
          className={'h-full w-full bg-black'}
          percent={instancesLength === undefined ||
            instancesLength === null || instancesLength === 0 ? 0 :
            Math.round((loadedCount * 100) / instancesLength)}
        />
      </div>
    );
    if (error !== "")
      return (
          <div style={{
              color: 'red',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              textAlign: 'center'
          }}>
              {error}
          </div>
      );

    if (instancesLength > 0) {
    return (
      <ImageViewerProvider StudyInstanceUIDs={studyInstanceUIDs}>
        {CombinedExtensionsContextProvider ? (
          <CombinedExtensionsContextProvider>
            <DragAndDropProvider>{LayoutComponent}</DragAndDropProvider>
          </CombinedExtensionsContextProvider>
        ) : (
          <DragAndDropProvider>{LayoutComponent}</DragAndDropProvider>
        )}
      </ImageViewerProvider>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center pt-48" style={{ textAlign: 'center' }}>
      <span style={{ color: 'white', fontSize: '150%' }}>{"No Image to View"}</span>
    </div>
  );
}

/**
 * Creates a combined context provider using the context modules from the extension manager.
 * @param {object} extensionManager - The extension manager instance.
 * @param {object} servicesManager - The services manager instance.
 * @param {object} commandsManager - The commands manager instance.
 * @returns {React.Component} - A React component that provides combined contexts to its children.
 */
function createCombinedContextProvider(extensionManager, servicesManager, commandsManager) {
  const extensionsContextModules = extensionManager.getModulesByType(
    extensionManager.constructor.MODULE_TYPES.CONTEXT
  );

  if (!extensionsContextModules?.length) {
    return;
  }

  const contextModuleProviders = extensionsContextModules.flatMap(({ module }) => {
    return module.map(aContextModule => {
      return aContextModule.provider;
    });
  });

  return ({ children }) => {
    return Compose({ components: contextModuleProviders, children });
  };
}
ModeRoute.propTypes = {
  mode: PropTypes.object.isRequired,
  dataSourceName: PropTypes.string,
  extensionManager: PropTypes.object,
  servicesManager: PropTypes.object,
  hotkeysManager: PropTypes.object,
  commandsManager: PropTypes.object,
};
function define(arg0: string[], factory: (CryptoJS: any) => any) {
  throw new Error('Function not implemented.');
}
